
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Code from 'components/Code'
import Table, { Row, Column } from 'components/Table'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3><inlineCode parentName="h3">{`withTheme`}</inlineCode></h3>
    <p>{`This is a higher order component factory to get the current theme from a `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` and
pass it to your component as a `}<inlineCode parentName="p">{`theme`}</inlineCode>{` prop.`}</p>
    <Table head={['Arguments', 'Description']} mdxType="Table">
  <Row mdxType="Row">
    <Column mdxType="Column">
      1. <Code mdxType="Code">Component</Code>
    </Column>
    <Column mdxType="Column">
      Any valid React component that can handle a <Code mdxType="Code">theme</Code> prop.
    </Column>
  </Row>
    </Table>
    <p>{`Returns the passed component inside a wrapper (higher order component).
The passed component will receive a `}<inlineCode parentName="p">{`theme`}</inlineCode>{` prop with the current theme object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { withTheme } from 'styled-components'

class MyComponent extends React.Component {
  render() {
    console.log('Current theme: ', this.props.theme)
    // ...
  }
}

export default withTheme(MyComponent)
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`All styled components `}<a parentName="p" {...{
          "href": "/docs/advanced#theming"
        }}>{`automatically receive the theme as a prop`}</a>{`, so this is only necessary if you wish to access the theme for other reasons.`}</p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;